export const ProfileData = [
  {
    id: 1,
    imgSrc: [
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_01.jpeg",
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_02.jpeg",
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_03.jpeg",
    ],
    likeNums: "❤️ 23 💬 1",
  },
  {
    id: 2,
    imgSrc: [
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_04.jpeg",
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_05.jpeg",
    ],
    likeNums: "❤️ 43 💬 1",
  },
  {
    id: 3,
    imgSrc: [
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_06.jpeg",
    ],
    likeNums: "❤️ 10 💬 1",
  },
  {
    id: 4,
    imgSrc: [
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_07.jpeg",
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_08.jpeg",
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_09.jpeg",
    ],
    likeNums: "❤️ 35 💬 1",
  },
  {
    id: 5,
    imgSrc: [
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_10.jpeg",
    ],
    likeNums: "❤️ 12 💬 1",
  },
  {
    id: 6,
    imgSrc: [
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_11.jpeg",
    ],
    likeNums: "❤️ 17 💬 1",
  },
  {
    id: 7,
    imgSrc: [
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_12.jpeg",
    ],
    likeNums: "❤️ 12 💬 1",
  },
  {
    id: 8,
    imgSrc: [
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_13.jpeg",
    ],
    likeNums: "❤️ 15 💬 1",
  },
  {
    id: 9,
    imgSrc: [
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_14.jpeg",
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_15.jpeg",
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_16.jpeg",
    ],
    likeNums: "❤️ 46 💬 1",
  },
  {
    id: 10,
    imgSrc: [
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_17.jpeg",
    ],
    likeNums: "❤️ 19 💬 1",
  },
  {
    id: 11,
    imgSrc: [
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_18.jpeg",
    ],
    likeNums: "❤️ 11 💬 1",
  },
  {
    id: 12,
    imgSrc: [
      "https://dongsooo.github.io/imgs/dongstgram_img/07_profile_img_19.jpeg",
    ],
    likeNums: "❤️ 20 💬 1",
  },
];
